import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

function DailyPriceIcon({ article }) {
  if (!article) return <> </>;
  const [isOpen, setIsOpen] = useState(false);
  const toggleTooltip = () => setIsOpen(!isOpen);
  const toolTipTargetId = ['dailyPriceToolTip', article.id].join('-');
  const toolTipText =
    'Denna artikel har dagspris. Slutgiltigt pris kommer synas på ordererkännande';
  return (
    <>
      {article.hasDailyPrice && (
        <>
          <span id={toolTipTargetId}>
            <FontAwesomeIcon
              className="ms-1 text-warning"
              icon={faCircleExclamation}
            />
          </span>
          <Tooltip
            isOpen={isOpen}
            target={toolTipTargetId}
            toggle={toggleTooltip}
            placement="top"
            popperClassName="tooltip-price-icon"
          >
            {toolTipText}
          </Tooltip>
        </>
      )}
    </>
  );
}
DailyPriceIcon.propTypes = {
  article: PropTypes.object,
};
DailyPriceIcon.defaultProps = {
  article: null,
};
export default DailyPriceIcon;
